module.exports = __webpack_public_path__ + "img/role02.57084b77.png";